import React, {useContext} from "react";
import {ReactSVG} from "react-svg";
import vtpl from "../../../../images/vtpl.svg";
import './VtplSelectBlockStyles.scss';
import {VTPLOptionComponent} from "./VtplOptionComponent";
import {VTPLNoOptionComponent} from "./VtplNoOptionComponent";
import {QuotationContext} from "../../../../contexts/QuotationContext";
import {MtplQuotation} from "../../../../model/quotation";
import {strings} from "../../../../strings/strings";
import useSwitchToNewContent from "../../../../utils/hooks/useSwitchToNewContent";

interface VTPLOption {
	premium: number;
	sumInsured: number;
	totalPremium: number;
}

interface VTPLSelectBlock {
	vtplOptions: VTPLOption[];
	error: boolean;
	isSmartDrive: boolean;
	onSelectListener: (sumInsured: number) => void;
}

export const VTPLSelectBlock = (props: VTPLSelectBlock) => {
	const {error, vtplOptions, onSelectListener, isSmartDrive} = props;
    const showNewContent = useSwitchToNewContent()

	const {selectedVtplSumInsured, setSelectedVtplSumInsured, setSelectedVtplCovered, setSelectedVtplPremium} = useContext<QuotationContext<MtplQuotation>>(QuotationContext);

	const onSelect = (sumInsured: number, premium: number) => {
		setSelectedVtplSumInsured(sumInsured);
		setSelectedVtplCovered(sumInsured > 0);
		setSelectedVtplPremium(premium);

		onSelectListener(sumInsured);
	};

	return (
		<div className={"vtpl-select"}>
			<div className={"vtpl-select__description"}>
				<div className={"vtpl-select__description__image"}>
					<ReactSVG src={vtpl}/>
				</div>
				<h1>{strings.packageVtplName}</h1>
				<div className="vtpl-select__description__text">
					<span>У разі ДТП, поліс Автоцивілки покриває витрати на суму:</span>
					<ul>
						<li><small>{showNewContent ? '500' : '320'} 000 грн</small> за збитки, нанесені життю та здоров’ю потерпілих</li>
						<li><small>{showNewContent ? '250' : '160'} 000 грн</small> за збитки, нанесені майну потерпілих</li>
					</ul>
					<span>За {showNewContent ? 'значною кількістю' : 'статистикою, більше ніж в 40%'} випадків ДТП{showNewContent ? '' : ','} завдані збитки перевищують {showNewContent ? '250' : '160'} 000 грн, тому ми пропонуємо розширити захист.</span>
				</div>

				<a target="_blank"
				   rel="noopener noreferrer"
				   href={`${process.env.PUBLIC_URL}/resources/Умови_Додаткова автоцивілка${showNewContent ? '_01.01.2025' : ''}.pdf`}>{strings.learnMoreAboutVtpl}</a>
			</div>
			<div className={"vtpl-select__options"}>
				{vtplOptions.map((value, index) => {
					return <VTPLOptionComponent id={index.toString()}
												key={index}
												error={error}
												premium={value.premium}
												selected={value.sumInsured === selectedVtplSumInsured}
												sumInsured={value.sumInsured}
												onSelect={onSelect}
												isSmartDrive={isSmartDrive}
												totalPremium={value.totalPremium}
					/>
				})}

				<VTPLNoOptionComponent error={error}
									   selected={selectedVtplSumInsured === 0}
									   onSelect={onSelect}/>

				{error && (
					<div className={"vtpl-select__options__error"}>
						<span>{strings.chooseOption}</span>
					</div>
				)}
			</div>
		</div>
	)
};
